(function ($, Drupal, window, document) {

  'use strict';
  var clicked_marker_id;

  Drupal.behaviors.interactive_map = {
    attach: function (context, settings) {
      $(once('click', '.marker-link')).click(function(e){
        e.preventDefault();
        clicked_marker_id = $(this).attr('data-id');
        $('.tippy-popper').remove();
        $('.hotspot[aria-expanded="true"]').attr('aria-expanded', 'false');
        $('.hotspot[data-entity-id="' + clicked_marker_id + '"]').click();
      });
    }
  };

})(jQuery, Drupal, this, this.document);
